import * as React from 'react';
import Dropzone from 'react-dropzone';
import cx from 'classnames';

import { getBase64FromFile } from '@common/utils/file';

import './FileUpload.styles.scss';

/*
type Config = Omit<DropzoneProps, 'accept' | 'maxSize'> & { accept: string[]; maxSize: number };

export interface FileUploadProps extends WithStyles<typeof styles> {
  config: Config;
  placeholder?: React.ReactNode;
  icon?: React.ReactNode;
  inputProps?: DropzoneInputProps;
  disabledMessage?: string;
  successMessage?: string;
  style?: CSSProperties;
  onUpload: (acceptedFiles: File[] | File) => any;
  onReject?: (rejectedFiles: FileRejection[] | FileRejection) => any;
}
*/

export class FileUpload  extends React.Component {
  static defaultProps = {
    disabledMessage: 'The maximum files amount is uploaded',
  };

  dropzoneRef = React.createRef();

  onDrop = async (acceptedFiles, rejectedFiles) => {
    const { onReject, config } = this.props;

    if (rejectedFiles.length) {
      if (onReject) {
        onReject(config.multiple ? rejectedFiles : rejectedFiles[0]);
      }

      return;
    }

    const { onUpload, withBase64 } = this.props;

    const uploadMetadata = [];

    for (const file of acceptedFiles) {
      const metadata = {
        file,
      };

      if (withBase64) {
        const base64 = await getBase64FromFile(file);

        metadata.base64 = base64;
      }

      uploadMetadata.push(metadata);
    }
    
    onUpload(config.multiple ? uploadMetadata : uploadMetadata[0]);
  }

  render() {
    const { placeholder, icon, config, inputProps, style, placeholderProps = {}, classes = {} } = this.props;

    return (
      <Dropzone
        ref={this.dropzoneRef}
        onDrop={this.onDrop}
        {...config}
      >
        {({ getRootProps, getInputProps }) => (
          <div role="button" {...getRootProps()} style={style} className={cx('FileUpload', { 'FileUpload-disabled': config.disabled }, classes.root)}>
            <input {...getInputProps(inputProps)} />
            <div className={cx('FileUpload__placeholder', classes.placeholder)}>
              {icon && <span className={cx('FileUpload__icon-wrapper', classes.iconWrapper)}>{icon}</span>}
              {placeholder && <div {...placeholderProps} className={cx('FileUpload__placeholder__text', classes.placeholderText)}>{placeholder}</div>}
            </div>
          </div>
        )}
      </Dropzone>
    );
  }
}
